import {
  HistoricoAtividadeColetivaQuery,
  HistoricoAtividadeColetivaReuniaoQuery,
  HistoricoAtividadeColetivaSaudeQuery,
} from 'graphql/types.generated'

export const PNCT_ABANDONOU_GRUPO = 'Abandonou o grupo'
export const PNCT_CESSOU_FUMAR = 'Cessou hábito de fumar'

export type HistoricoAtividadeColetivaDwSaudeModel = HistoricoAtividadeColetivaQuery['historicoAtividadeColetiva']
export type HistoricoAtividadeColetivaSaudeModel = HistoricoAtividadeColetivaSaudeQuery['atividadeColetiva']
export type HistoricoAtividadeColetivaReuniaoModel = HistoricoAtividadeColetivaReuniaoQuery['atividadeColetiva']
